export default {
  title: 'Sugestões de IA',
  subtitle: 'Sugestões do agente FoodAmigos para os seus restaurantes.',
  empty: 'Nada para mostrar aqui.',
  tabs: {
    pending: 'Pendente',
    history: 'Histórico',
  },
  table: {
    id: 'ID',
    company: 'Restaurante',
    type: 'Tipo',
    summary: 'Sugestão',
    created_at: 'Criado',
    status: 'Estado',
    actions: 'Ações',
  },
  statuses: {
    pending: 'Pendente',
    confirmed: 'Confirmado',
    applied: 'Aplicado',
    rejected: 'Rejeitado',
    failed: 'Falhado',
    expired: 'Expirado',
  },
  types: {
    'smart_pricing.global_reduce': 'Desconto em todo o menu',
    'smart_pricing.category_reduce': 'Desconto por categoria',
    'competitor_listing.confirm': 'Confirmar listagem no marketplace',
    'catalog.price_correct': 'Correção de preço',
    'catalog.add_item': 'Adicionar item em falta',
    'catalog.quality': 'Qualidade do conteúdo',
    'catalog.reorder': 'Reordenação do menu',
  },
  actions: {
    review: 'Rever',
    confirm: 'Confirmar',
    reject: 'Rejeitar',
    cancel: 'Cancelar',
    edit: 'Editar',
  },
  edit: {
    label: 'Descreva a alteração pretendida (é gerada uma nova revisão)',
    placeholder: 'Descreva a alteração pretendida',
    placeholders: {
      'smart_pricing.global_reduce': 'ex.: definir 15%, renomear para «Verão -15%» ou aplicar apenas em entrega',
      'smart_pricing.category_reduce': 'ex.: definir o desconto de Bebidas a 10% e remover takeaway',
      'catalog.price_correct': 'ex.: remover a correção «Cola» ou definir «Pizza» a €7,50',
      'catalog.add_item': 'ex.: remover o item «Water» ou definir o preço de «Falafel Wrap» a €6,50',
      'catalog.quality': 'ex.: remover os items «Fries» e «Cola» da lista',
      'catalog.reorder': 'ex.: colocar Bebidas no fim e mover o mais vendido para o topo de Bowls',
      'competitor_listing.confirm': 'ex.: substituir o link do Uber Eats por https://…, ou adicionar Wolt: https://…',
    },
    submit: 'Gerar revisão',
  },
  revisions: {
    label: 'Revisão',
    original: 'Original',
    revision_n: 'Revisão {{n}}',
  },
  detail: {
    title: 'Detalhe da sugestão',
    targets: 'Itens afetados',
    evidence: 'Porque é que o agente sugere isto',
    no_targets: 'Nenhum detalhe de item fornecido.',
    composed_from: 'Composto por',
    items_suffix: 'itens',
    nutrition: 'Nutrição',
    uncategorized: 'Sem categoria',
    decided_by: 'Decidido por',
    decision_note: 'Nota',
    category_existing: 'existente',
    category_new: 'novo',
    product: 'Produto',
    price_change: 'Alteração de preço',
    no_items: 'Sem items',
    fills_image: '+ imagem',
    fills_description: '+ descrição',
    fills_nutrition: '+ nutrição',
    fills_modifiers: '+ modificadores',
    competitor_links: 'Links de concorrentes',
    no_competitor_links: 'Sem links de concorrentes resolvidos ainda.',
  },
  competitors: {
    lieferando: 'Lieferando',
    wolt: 'Wolt',
    deliveroo: 'Deliveroo',
    uber_eats: 'Uber Eats',
  },
  reject_modal: {
    title: 'Rejeitar esta sugestão',
    note_label: 'Motivo',
    note_placeholder: 'Explique brevemente porque está a rejeitar esta sugestão',
  },
  toasts: {
    load_failed: 'Falha ao carregar sugestões',
    confirmed: 'Sugestão confirmada',
    rejected: 'Sugestão rejeitada',
    action_failed: 'Não foi possível concluir essa ação',
    revision_created: 'Nova revisão gerada',
    revision_failed: 'Não foi possível gerar uma revisão com essa instrução',
    choose_revision: 'Esta sugestão tem várias revisões — abra-a e escolha uma para confirmar',
  },
};
